module.exports = __webpack_public_path__ + "img/wlwtms_banner.9819040a.png";